export default "__VITE_ASSET__C9cC4y38__"